import titleImg from "@/assets/quick-img/wenan.png";
import moban from "@/assets/quick-img/moban.png";
import musicImg from "@/assets/quick-img/music.png";
import lujImg from "@/assets/quick-img/lujing.png";
import "./ConfigTab.less";
import React, { useState } from "react";

const tagDataList = [
  {
    icon: <img src={titleImg} />,
    text: "文案描述",
    id: 1,
    left: 0
  },
  {
    icon: <img src={moban} />,
    text: "模板",
    id: 2,
    left: 118
  },
  {
    icon: <img src={musicImg} />,
    text: "背景音乐",
    id: 3,
    left: 118 * 2
  },
  {
    icon: <img src={lujImg} />,
    text: "特效滤镜",
    id: 4,
    left: 118 * 3
  },
];

interface IConfigTag {
  activeKey: number;
  handleActiveIndexChange: (e: number) => void;
  global?: boolean;
  videoActiveIndex: number;
}


const ConfigTag: React.FC<IConfigTag> = (props) => {
  const { activeKey, handleActiveIndexChange, global, videoActiveIndex } =
    props;
  // const [disabled, setDisabled] = useState([0, 1, 2]);
  const [activeLeft, setActiveLeft] = useState(0);
  const [activeId, setActiveId] = useState(1);
  return (
    <ul className="video-config-tab-header1">
      {tagDataList.map((item, index) => {
        return (
          <li
            key={item.text + index}
            onClick={(e) => {
              setActiveId(item.id);
              setActiveLeft(item.left);
              handleActiveIndexChange(item.id);
            }}
            className={`${activeId === item.id ? "active" : ""}`}>
            <div className="img-wrapper">
              {item.icon}
            </div>
            <p>{item.text}</p>
          </li>
        );
      })}
      <div className={'active-box'} style={{ transform: `translateX(${activeLeft}px)` }}/>
    </ul>
  );
};

export default ConfigTag;
